module.exports = __webpack_public_path__ + "img/document-placeholder.8bf4914a.jpeg";